



























































































import {Vue, Component} from "vue-property-decorator";
import {EventBus} from "@/helpers/event-bus";
import SurveyFooter from "@/components/SurveyFooter.vue";
import SurveyStepper from "@/components/SurveyStepper.vue";
import SurveyTab from "@/components/SurveyTab.vue";
import {SurveyTabCollectionType} from "@/types/surveyComponent.type";
import {FullSurveyType, SurveyTabType} from "@/types/surveyTab.type";

@Component({
    components: {SurveyFooter, SurveyStepper, SurveyTab}
})
export default class Survey extends Vue {
    currentTab = 1;

    saveDialog = false;

    userDefinedFileName: string | null = null;
    dataDownload: null | string = null;
    dataBlob: null | Blob = null;
    fulldata: FullSurveyType | null = null;

    mounted() {
        this.$store.commit("setSurveyTouched", true);
    }

    nextTab(direction: string) {
        if (
            direction == "next" &&
            this.currentTab < Object.keys(this.surveyTabs).length
        ) {
            if (this.disabledTabs.includes(this.currentTab + 1)) {
                if (
                    this.currentTab + 2 <=
                    Object.keys(this.surveyTabs).length
                ) {
                    this.currentTab = this.currentTab + 2;
                }
            } else {
                this.currentTab++;
            }
        } else if (direction == "back" && this.currentTab > 1) {
            if (this.disabledTabs.includes(this.currentTab - 1)) {
                if (
                    this.currentTab - 2 >=
                    Object.keys(this.surveyTabs).length
                ) {
                    this.currentTab = this.currentTab - 2;
                }
            } else {
                this.currentTab--;
            }
        }
    }

    setTab(step: number) {
        EventBus.$emit("update-tab-data");
        this.currentTab = step;
    }

    setStore(value: SurveyTabType) {
        if (this.currentHeader == this.surveyTabs[1].name) {
            this.$store.commit("setVoterRegistrationQuestions", value);
            this.$store.commit("setVoterRegistrationVisited", true);
        } else if (this.currentHeader == this.surveyTabs[2].name) {
            this.$store.commit("setPollbookPrepQuestions", value);
            this.$store.commit("setPollbookPrepVisited", true);
        } else if (this.currentHeader == this.surveyTabs[3].name) {
            this.$store.commit("setPollbookUseQuestions", value);
            this.$store.commit("setPollbookUseVisited", true);
        } else if (this.currentHeader == this.surveyTabs[4].name) {
            this.$store.commit("setBallotPrepQuestions", value);
            this.$store.commit("setBallotPrepVisited", true);
        } else if (this.currentHeader == this.surveyTabs[5].name) {
            this.$store.commit("setVotingMachinePrepQuestions", value);
            this.$store.commit("setVotingMachinePrepVisited", true);
        } else if (this.currentHeader == this.surveyTabs[6].name) {
            this.$store.commit("setVotingMachineUseQuestions", value);
            this.$store.commit("setVotingMachineUseVisited", true);
        } else if (this.currentHeader == this.surveyTabs[7].name) {
            this.$store.commit("setTabulationPrepQuestions", value);
            this.$store.commit("setTabulationPrepVisited", true);
        } else if (this.currentHeader == this.surveyTabs[8].name) {
            this.$store.commit("setPrecinctTabulationQuestions", value);
            this.$store.commit("setPrecinctTabulationVisited", true);
        } else if (this.currentHeader == this.surveyTabs[9].name) {
            this.$store.commit("setCentralTabulationQuestions", value);
            this.$store.commit("setCentralTabulationVisited", true);
        } else if (this.currentHeader == this.surveyTabs[10].name) {
            this.$store.commit("setAggregationQuestions", value);
            this.$store.commit("setAggregationVisited", true);
        } else if (this.currentHeader == this.surveyTabs[11].name) {
            this.$store.commit("setWebsiteQuestions", value);
            this.$store.commit("setWebsiteVisited", true);
        }
    }

    get disabledTabs(): number[] {
        const disabledTabs = [];
        for (const [key, value] of Object.entries(this.surveyTabs)) {
            if (value.hideStep) {
                disabledTabs.push(value.step);
            }
        }
        return disabledTabs;
    }

    get currentHeader() {
        return this.surveyTabs[this.currentTab].name;
    }

    get currentTabData() {
        if (this.currentHeader === this.surveyTabs[1].name) {
            return this.voterRegistrationQuestions;
        } else if (this.currentHeader === this.surveyTabs[2].name) {
            return this.pollbookPrepQuestions;
        } else if (this.currentHeader === this.surveyTabs[3].name) {
            return this.pollbookUseQuestions;
        } else if (this.currentHeader === this.surveyTabs[4].name) {
            return this.ballotPrepQuestions;
        } else if (this.currentHeader === this.surveyTabs[5].name) {
            return this.votingMachinePrepQuestions;
        } else if (this.currentHeader === this.surveyTabs[6].name) {
            return this.votingMachineUseQuestions;
        } else if (this.currentHeader === this.surveyTabs[7].name) {
            return this.tabulationPrepQuestions;
        } else if (this.currentHeader === this.surveyTabs[8].name) {
            return this.precinctTabulationQuestions;
        } else if (this.currentHeader === this.surveyTabs[9].name) {
            return this.centralTabulationQuestions;
        } else if (this.currentHeader === this.surveyTabs[10].name) {
            return this.aggregationQuestions;
        } else if (this.currentHeader === this.surveyTabs[11].name) {
            return this.websiteQuestions;
        } else {
            return null;
        }
    }

    get voterRegistrationQuestions() {
        return this.$store.getters.voterRegistrationQuestions;
    }

    get pollbookPrepQuestions() {
        return this.$store.getters.pollbookPrepQuestions;
    }

    get pollbookUseQuestions() {
        return this.$store.getters.pollbookUseQuestions;
    }

    get ballotPrepQuestions() {
        return this.$store.getters.ballotPrepQuestions;
    }

    get votingMachinePrepQuestions() {
        return this.$store.getters.votingMachinePrepQuestions;
    }

    get votingMachineUseQuestions() {
        return this.$store.getters.votingMachineUseQuestions;
    }

    get tabulationPrepQuestions() {
        return this.$store.getters.tabulationPrepQuestions;
    }

    get precinctTabulationQuestions() {
        return this.$store.getters.precinctTabulationQuestions;
    }

    get centralTabulationQuestions() {
        return this.$store.getters.centralTabulationQuestions;
    }

    get aggregationQuestions() {
        return this.$store.getters.aggregationQuestions;
    }

    get websiteQuestions() {
        return this.$store.getters.websiteQuestions;
    }

    get surveyTabs(): SurveyTabCollectionType {
        return this.$store.getters.surveyTabs;
    }

    get isIE() {
        return this.$store.getters.isIE;
    }

    get fileName() {
        if (this.userDefinedFileName !== null) {
            return this.userDefinedFileName.toString() + ".txt";
        } else {
            return "data.txt";
        }
    }

    setUpSave() {
        this.fulldata = {
            voterRegistrationQuestions: this.voterRegistrationQuestions,
            pollbookPrepQuestions: this.pollbookPrepQuestions,
            pollbookUseQuestions: this.pollbookUseQuestions,
            ballotPrepQuestions: this.ballotPrepQuestions,
            votingMachinePrepQuestions: this.votingMachinePrepQuestions,
            votingMachineUseQuestions: this.votingMachineUseQuestions,
            tabulationPrepQuestions: this.tabulationPrepQuestions,
            precinctTabulationQuestions: this.precinctTabulationQuestions,
            centralTabulationQuestions: this.centralTabulationQuestions,
            aggregationQuestions: this.aggregationQuestions,
            websiteQuestions: this.websiteQuestions,
            voterRegistrationVisited: this.$store.getters
                .voterRegistrationVisited,
            pollbookPrepVisited: this.$store.getters.pollbookPrepVisited,
            pollbookUseVisited: this.$store.getters.pollbookUseVisited,
            ballotPrepVisited: this.$store.getters.ballotPrepVisited,
            votingMachinePrepVisited: this.$store.getters
                .votingMachinePrepVisited,
            votingMachineUseVisited: this.$store.getters
                .votingMachineUseVisited,
            tabulationPrepVisited: this.$store.getters.tabulationPrepVisited,
            precinctTabulationVisited: this.$store.getters
                .precinctTabulationVisited,
            centralTabulationVisited: this.$store.getters
                .centralTabulationVisited,
            aggregationVisited: this.$store.getters.aggregationVisited,
            websiteVisited: this.$store.getters.websiteVisited
        };

        this.saveDialog = true;

        this.dataBlob = new Blob([JSON.stringify(this.fulldata, null, 2)], {
            type: "text/plain"
        });

        this.dataDownload = URL.createObjectURL(this.dataBlob);
    }

    saveFile() {
        window.navigator.msSaveBlob(this.dataBlob, this.fileName);
        this.saveDialog = false;
    }
}
